import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Shortcuts from './Shortcuts';
import {RoundCheckbox} from './RoundCheckbox';
import {Button} from 'react-bootstrap';

export default class Support extends Component {

    render() {
        const navButtonStyle = {display: 'inline-block', backgroundColor: '#4285f4', color: 'white', padding: '0 5px'};
        return (
            <div className="page support">
                <div className="page_contents">
                    <h1>Support</h1>
                    <div className="card">
                        <h3>Getting Started</h3>
                        <br/>
                        <h4>Create a Free Account and Pop Some Images</h4>

                        <ol start="1">
                            <li><p><Link to="/register">Register</Link> for a free account, and <Link to="/login">login</Link>.</p></li>
                            <li><p>Go to the <Link to="/images/my">my images</Link> page (see top navigation bar).</p></li>
                            <li><p>Upload images (one or several at a time) using the green <Button bsSize="xsmall" bsStyle="success"><i className="fa fa-upload"/> Upload</Button> button, or drag and
                                drop images from folders on your computer directly into the <em>my images</em> page.</p>
                            </li>
                            <li><p>When the deep contrast engine has finished "popping" your images (it takes from 1 to a few minutes depending on the load),
                                they will appear in the <em>my images</em> grid. The popping process continues even if you logout or lose web
                                connectivity. Just come back later to <em>my images</em> to see the results!</p>
                            </li>
                        </ol>
                        <h4>Check Out The Results</h4>

                        <ol start="1">
                            <li>
                                <p><strong>Selecting/Viewing an image.</strong> Click on an image to view or edit. Or to select multiple images for viewing, select the first one (click the checkmark
                                    {' '}
                                    <div style={{backgroundColor: 'gray', display: 'inline-block'}}><RoundCheckbox size={20} active={true}/></div>
                                    on the upper
                                    left of the thumbnail), and then click on any other images you want to include in the selection. You can select multiple consecutive images by holding down the
                                    {' '}<kbd>shift</kbd>{' '} key,
                                    while making the selection. To enter the viewer with multiple images selected, click the magnifying glass icon <i className="fa fa-search-plus"/> on any of the
                                    thumbnails, or on the top blue selection bar.
                                </p>
                            </li>
                            <li><p><strong>Compare popped and original versions.</strong> Once in the viewer, you can toggle back and forth between the original and popped images using the
                                {' '}<kbd>space</kbd>{' '} key.
                            </p>
                            </li>
                            <li><p><strong>Use presets, or change settings manually.</strong> Nine presets are available: type digits {' '}<kbd>1</kbd>, <kbd>2</kbd>, ...<kbd>9</kbd>, or click on the
                                numbered
                                circles at the top of the viewer. When the
                                preset is lit, the popped image is showing. To toggle back to the original, use the {' '}<kbd>space</kbd>{' '} key, or type the digit, or click on the numbered preset button.
                                "Amplitude"
                                and "Spread" values are shown on the control panel to the right. Amplitude changes the amount of contrast, and Spread makes the contrast at boundaries appear sharper
                                (low numbers), or broader (high numbers). You can use the Amp and Spread controls on the panel to change the values manually.</p>
                            </li>
                            <li><p><strong>Choosing preferred settings and applying them to multiple images.</strong> In the viewer, when you find the best combination of Amplitude and Spread settings
                                for an
                                image, type {' '}<kbd>p</kbd>{' '} or click the "thumbs up" icon <i className="fa fa-thumbs-o-up"/> on the top control bar to indicate these are your "preferred" settings. This
                                choice will determine the settings used when
                                printing or saving images. You can propagate preferred Amplitude and Spread settings to all of the images in the current selection using the item on the pulldown menu
                                next to the thumb. This allows you try out settings for the first few images of a collection, and when you find ones that work well, apply them to the entire collection
                                without having to view each image individually.</p>
                            </li>
                            <li><p><strong>View the "contrast" image by toggling the {' '}<kbd>c</kbd>{' '} key.</strong> This shows you where your image will be brightened or darkened. In grey areas, the
                                original image
                                will be left unchanged (which is generally most of the image). When you're in "contrast mode", which you will know because the "c" button is lit on the upper panel, you
                                can still toggle back and forth to the original using the {' '}<kbd>space</kbd>{' '} key. To exit contrast mode, hit the {' '}<kbd>c</kbd>{' '} key one more time.</p>
                            </li>
                            <li><p><strong>Zoom or pan the image.</strong> On a mac, use trackpad gestures as you would in Preview, or the zoom and pan tools on the panel. In pan/zoom mode (when a
                                pan/zoom tool is selected), you can zoom with {' '}<kbd>+</kbd>{' '} and {' '}<kbd>-</kbd>{' '} keys, and pan with arrow keys. To exit pan/zoom mode, use the {' '}<kbd>.</kbd>{' '} (period) key.
                                Reset
                                the view by typing the {' '}<kbd>`</kbd>{' '} (back-tick) key, or using the <Button bsSize="xsmall"><i className="fa fa-step-backward"/> Reset</Button> button.</p>
                            </li>
                        </ol>

                        <h4>Editing the Contrast Image</h4>

                        <ol start="1">
                            <li><p><strong>Erasing: </strong> Sometimes image features get enhanced that you'd rather not call attention to (e.g. clouds, shadows, wrinkles). Use the brush tool (type
                                {' '}{' '}<kbd>b</kbd>{' '}) to wipe the unwanted enhancements off the picture. You can erase on either the popped or contrast image (but not the original). On the
                                contrast
                                image,
                                erasing returns the pixels to grey. Cycle through different brush sizes by typing {' '}<kbd>b</kbd>{' '} or click on the brush size you want on the panel.
                            </p>
                            </li>
                            <li><p><strong>Erasing vs. Reducing vs. Increasing: </strong> In "Reduce" mode (type {' '}<kbd>r</kbd>{' '}) when you brush over a feature, the deep contrast effect is reduced by
                                half. You
                                can reduce even more by brushing over an area more than once. In "Increase" mode (type {' '}<kbd>i</kbd>{' '}), you increase the effect by 50%. You can increase repeatedly as
                                well. You
                                can always see what's happening by looking at the contrast image.
                            </p>
                            </li>
                            <li>
                                <p><strong>Erasing by Lassoing: </strong>Similar to brushing, you can erase, reduce, or increase using the lasso tool (type {' '}<kbd>l</kbd>{' '}). There are 4 versions:
                                    <ul>
                                        <li>regular lasso, which lets you encircle what you want to erase,</li>
                                        <li>inverse lasso, which erases outside what you encircle,</li>
                                        <li>rectangle – drag to erase inside, and</li>
                                        <li>inverse rectangle – drag to erase outside.</li>
                                    </ul>
                                    Lasso and rectangle tools can be used in Reduce and Increase modes as well.
                                </p>
                            </li>
                            <li>
                                <p><strong>Undoing/Redoing: </strong>
                                    If you change your mind about an edit, use the <Button bsSize="xsmall"><i className="fa fa-undo"/> Undo</Button> and
                                    <Button bsSize="xsmall"><i className="fa fa-repeat"/> Redo</Button> buttons (or use {' '}<kbd>cmd-z</kbd>{' '} to undo and {' '}<kbd>cmd-y</kbd>{' '} to redo). You can also hide and show or
                                    eliminate specific
                                    edits using the Edits menu. Roll the cursor down the menu to see the edits on the image. You can also reset all your edits in a single click with the <Button
                                        bsSize="xsmall"><i className="fa fa-step-backward"/> Reset</Button> button .
                                </p>
                            </li>
                        </ol>

                        <h4>Moving to the Next or Previous Image</h4>

                        <ol start="1">
                            <li><p><strong>Use left and right arrow keys {' '}<kbd>{'←'}</kbd>{' '}{' '}{' '}<kbd>{'→'}</kbd>{' '} to move to the next or previous image. </strong> The ordering will be the same as the
                                current ordering on the <em>my images</em> page.<br/><br/>

                                Or, if you have selected images in <em>my images</em>, you have the option to:
                            </p>
                            </li>
                            <li><p><strong>Use up and down arrow keys {' '}<kbd>{'↑'}</kbd>{' '}{' '}{' '}<kbd>{'↓'}</kbd>{' '} to move to move through selected images (if any). </strong> The ordering will be the same
                                as the current ordering of the selection on the <em>my images</em> page.
                            </p>
                            </li>
                            <li>
                                <p><strong>You can also use the arrow buttons on the upper control bar. </strong>
                                    <ul>
                                        <li>use the grey arrows <i className="fa fa-chevron-circle-left"/> <i className="fa fa-chevron-circle-right"/> at upper left to move through all images</li>
                                        <li>use the blue arrows <div style={navButtonStyle}><i className="fa fa-chevron-circle-down"/> <i className="fa fa-chevron-circle-up"/></div> at upper right to move through selected images (if
                                            you have a current selection)
                                        </li>
                                    </ul>
                                </p>
                            </li>
                        </ol>

                        <h4>Opening, Saving, and Printing from the Viewer</h4>

                        <ol start="1">
                            <li><p><strong>Opening a new image from your computer. </strong> Type {' '}<kbd>cmd-o</kbd>{' '} or click the upload icon <i className="fa fa-upload"/> on the top control bar.
                            </p>
                            </li>
                            <li><p><strong>Save an image to your computer. </strong> Type {' '}<kbd>cmd-s</kbd>{' '} or click the Download icon <i className="fa fa-download"/> on the top control bar. The image
                                on
                                the
                                screen will be the one saved, whether
                                popped, original, or contrast. The file name will memorialize the Amp and Spread settings, and will contain an 'm' if you modified the image with editing tools. Images
                                are saved and printed at full original resolution.
                            </p>
                            </li>
                            <li><p><strong>Print an image. </strong>Type {' '}<kbd>cmd-p</kbd>{' '} or click the Print icon <i className="fa fa-print"/> on the top control bar.
                            </p>
                            </li>
                        </ol>

                        <h4>Opening, Saving, and Printing from the <em>my images</em> page</h4>

                        <ol start="1">
                            <li><p><strong>Opening one or more new images from your computer. </strong> Type {' '}<kbd>cmd-o</kbd>{' '} or click the green upload button <Button bsSize="xsmall" bsStyle="success"><i className="fa fa-upload"/> Upload</Button> at
                                the top,
                                or drag and drop one or more images from your desktop into the page.
                            </p>
                            </li>
                            <li><p><strong>Save one or more images to your computer. </strong> Select one or more images (see item "Selecting/Viewing an Image"), then type {' '}<kbd>cmd-s</kbd>, or click
                                the Download icon <i className="fa fa-download"/> on the blue selection bar.
                            </p>
                            </li>
                            <li><p><strong>Print one or more images. </strong>Select one or more images (see item "Selecting/Viewing an Image"), then type {' '}<kbd>cmd-p</kbd>{' '} or click the Print icon <i
                                className="fa fa-print"/> on the blue
                                selection bar.
                            </p>
                            </li>
                        </ol>

                        <h4>Preferred Browser: Google Chrome</h4>
                        <ol style={{listStyle: 'none'}}>
                            <li><p>On a Mac, Google Chrome is the preferred browser for popping images since it allows you to use the same trackpad
                                navigation
                                gestures as in Preview and other mac applications, including pinching to zoom (very useful). In other browsers,
                                including
                                Firefox and Safari, you will zoom in and zoom out using tools – pinching is ignored or has other effects. The most
                                recent
                                version of Google Chrome can be downloaded <a href="https://www.google.com/chrome/browser/desktop/index.html">here</a>.
                            </p>
                            </li>
                        </ol>
                        <br/>
                        <h3>Keyboard Shortcuts</h3>
                        <ol style={{listStyle: 'none'}}>
                            <li>
                                <p>To see the keyboard shortcuts from anywhere on the site, type {' '}<kbd>?</kbd>{' '}</p>
                                <Shortcuts/>
                            </li>
                        </ol>
                        <br/>
                        <h3>Technical Support</h3>
                        <ol style={{listStyle: 'none'}}>
                            <li>
                                <p>
                                    For technical support, send email to <a href="mailto:support@deepcontrast.com">support@deepcontrast.com</a>.
                                </p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Support.js